import React, { useState, useEffect } from "react"
import { Card, CardBody, Col, Row, Label, Input, Table } from "reactstrap";
import { metadataService } from "../../_services";
import { SlMoneyInput } from "../editors/SlMoneyInput";
import { PaymentBreakdown } from ".";
import PropTypes from 'prop-types';

export const SelectPaymentAmount = (props) => {
    const PAYMENT_SUGGESTED = 'suggested';
    const PAYMENT_PAYOFF = 'payoff';
    const PAYMENT_OTHER = 'other';

    const INPUT_NAME = "paymentType";

    const [paymentType, setPaymentType] = useState(PAYMENT_SUGGESTED);
    const [otherAmount, setOtherAmount] = useState('');

    useEffect(() => {

        if (paymentType === PAYMENT_OTHER) {
            props.onAmountChange(otherAmount);
            return;
        }

        setOtherAmount('');

        if (paymentType === PAYMENT_SUGGESTED) {
            props.onAmountChange(props.loanToPay.suggestedPayment);
        } else if (paymentType === PAYMENT_PAYOFF) {
            props.onAmountChange(props.loanToPay.payoff);
        }

    }, [paymentType, otherAmount])

    return (
        <Card>
            <CardBody>

                <Row
                    className={'selectable-row' + (paymentType === PAYMENT_SUGGESTED ? ' selected' : '')}
                    onClick={() => setPaymentType(PAYMENT_SUGGESTED)}
                >
                    <Col xs={6} sm={5}>
                        <Label className='mb-0 d-flex'>
                            <Input type="radio" name={INPUT_NAME} value={PAYMENT_SUGGESTED} className='position-relative d-block mx-2 my-0'
                                checked={paymentType === PAYMENT_SUGGESTED} onChange={() => { setPaymentType(PAYMENT_SUGGESTED) }} />
                            <p className='paymentLabel'>{metadataService.getFieldNameLabel('Payment')}</p>
                            <p className="paymentSubLabel p-0">&nbsp; {metadataService.getMessage('includesSchedule')}</p>
                        </Label>
                    </Col>

                    <Col className='text-center twisty' aria-expanded={paymentType === PAYMENT_SUGGESTED}>
                        <span className='h3'>{metadataService.formatMoney(props.loanToPay.suggestedPayment)}</span>
                    </Col>
                    <p className="paymentSubLabelMobile p-0">&nbsp; {metadataService.getMessage('includesSchedule')}</p>
                </Row>
                {paymentType === PAYMENT_SUGGESTED &&
                    <Table bordered={true} visible={false}>
                        <PaymentBreakdown loan={props.loanToPay} breakdownType='payment' />
                    </Table>
                }

                <Row
                    className={'selectable-row' + (paymentType === PAYMENT_PAYOFF ? ' selected' : '')}
                    onClick={() => setPaymentType(PAYMENT_PAYOFF)}
                >
                    <Col xs={6} sm={5}>
                        <Label className='mb-0 d-flex'>
                            <Input type="radio" name={INPUT_NAME} value={PAYMENT_PAYOFF} className='position-relative d-block mx-2 my-0'
                                checked={paymentType === PAYMENT_PAYOFF} onChange={() => { setPaymentType(PAYMENT_PAYOFF) }} />
                            <p className='paymentLabel'>{metadataService.getFieldNameLabel('PayoffAmount')}</p>
                        </Label>
                    </Col>

                    <Col className='text-center twisty' aria-expanded={paymentType === PAYMENT_PAYOFF}>
                        <span className='h3'>{metadataService.formatMoney(props.loanToPay.payoff)}</span>
                    </Col>
                </Row>
                {paymentType === PAYMENT_PAYOFF &&
                    <Table bordered={true}>
                        <PaymentBreakdown loan={props.loanToPay} breakdownType='payoff' />
                    </Table>
                }

                <Row
                    className={'selectable-row' + (paymentType === PAYMENT_OTHER ? ' selected' : '')}
                    onClick={() => setPaymentType(PAYMENT_OTHER)}
                >
                    <Col xs={6} sm={5}>
                        <Label className='mb-0 d-flex'>
                            <Input type="radio" name={INPUT_NAME} value={PAYMENT_OTHER} className='position-relative d-block mx-2 my-0'
                                checked={paymentType === PAYMENT_OTHER} onChange={() => { setPaymentType(PAYMENT_OTHER) }} />
                            <p className='paymentLabel'>{metadataService.getFieldNameLabel('OtherAmount')}</p>
                        </Label>
                    </Col>
                    <Col className='pt-3'>
                        <SlMoneyInput
                            name="PaymentAmount"
                            type="number"
                            step={.05}
                            maxValue={props.loanToPay.payoff}
                            value={otherAmount}
                            onChange={event => setOtherAmount(event.target.value)}
                            enforceMaxLength={false}
                            showLabel={false}
                            isRequired={paymentType === PAYMENT_OTHER}
                        />
                    </Col>
                </Row>
            </CardBody>
        </Card>
    )
}

SelectPaymentAmount.propTypes = {
    loanToPay: PropTypes.object.isRequired,
    onAmountChange: PropTypes.func.isRequired
}